import CustomStatisticalControlBatchDetail from '../../components/CustomStatisticalControlBatchDetail';

const StatisticalControlBatchDetail = () => {
  return <CustomStatisticalControlBatchDetail normative="ehe" />;
};

export default StatisticalControlBatchDetail;
